var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWindowsBack = function SvgWindowsBack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "694.029 -5213.595 9.971 9.189"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M704-5209.312v.625h-8.779l3.842 3.842-.439.439-4.595-4.594 4.595-4.595.439.439-3.842 3.844Z"
  })));
};
export default SvgWindowsBack;